// extracted by mini-css-extract-plugin
module.exports = {"searchForm":"_2v1n9","focusedForm":"_33Dew","searchBoxExpand":"_2uOX-","unfocusedForm":"_2SD7T","searchBoxShrink":"_3-PLW","topLayout":"ua2eM"};